import * as type from './type';
import util from 'common/js/util';

export default {
    //获取代下单数据列表
    [type.GET_CLIENT_ORDER_LIST](context, option) {
        util.post({
            params: {
                functionId: "queryClientOrderList",
                body: JSON.stringify({
                    clientPin: option.params.clientPin,
                    pageNo: option.params.pageNo,
                    pageSize: option.params.pageSize,
                    orderQueryType: option.params.orderQueryType,
                    roleType: option.params.roleType,
                    jdOrderId: option.params.jdOrderId,
                    btoId: option.params.btoId,
                    skuName: option.params.skuName,
                    btoStatus: option.params.btoStatus,
                })
            },
            sc(data) {
                if (option && option.sc) {
                    option.sc && option.sc(data);
                }
            },
            fc(data) {
                if (option && option.fc) {
                    option.fc && option.fc(data);
                }
            }
        });
    },
}


// WEBPACK FOOTER //
// ./src/store/agent-purchase-list/actions.js